import React from "react";
import { historyDetailsPaymentsColumn } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import Translator from "Languages/Utility/Translator";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

export default function HistoryDetailsPayments({ loading, data }) {
  return (
    <>
      {data ? (
        <RemoteTable
          data={data}
          columns={historyDetailsPaymentsColumn}
          noTitle
          showPagination={false}
          // title={<Translator id="history_payments" />}
        />
      ) : (
        <div className="d-flex flex-row justify-content-center align-items-center ">
          {loading ? <InnerCircularProgress /> : <Translator id="noEditedItem" />}
        </div>
      )}
    </>
  );
}
